module.exports = __webpack_public_path__ + "img/icon7.b2cf9c8b.png";